import * as React from "react";
import { useEffect, useState } from "react";
import { Pagination } from "./Pagination";
import Each from "./Each";
import {
  Main,
  TableContainer,
  MainTable,
  Thead,
  Row,
  Td,
  Th,
  CollapseCell,
  PaginationContainer,
} from "./styles";

type Column = {
  header: string | React.ReactNode;
  width?: string;
  style?: React.CSSProperties;
  headingClassName?: string;
  accessor: (
    data: any | undefined | null,
    index?: number,
    rowIndex?: number
  ) => React.ReactNode;
};

type TableProps = {
  columns: Column[];
  data: any[];
  isPaginated: boolean;
  pageNo: number;
  setPageNo: (pageNo: number) => void;
  totalPages: number;
  tableClassName?: string;
  pageSize?: number;
  isCollapse?: boolean;
  isMultiCollapse?: boolean;
  CollapseChild?: React.FC<{ data: any; index: number }> | undefined;
  collapseRowClass?: string;
  responsiveType?: "scroll" | "card";
  prevBtnLabel?: string | React.ReactNode;
  nextBtnLabel?: string | React.ReactNode;
};

const Table: React.FC<TableProps> = ({
  columns,
  data,
  isPaginated,
  pageNo = 1,
  setPageNo,
  totalPages = 0,
  tableClassName = "",
  pageSize = data?.length || 0,
  isCollapse,
  prevBtnLabel,
  nextBtnLabel,
  CollapseChild,
  isMultiCollapse,
  collapseRowClass = "",
  responsiveType = "scroll",
}) => {
  const [activeRow, setActiveRow] = useState<boolean[]>([]);

  useEffect(() => {
    if (isCollapse) {
      setActiveRow(data.map(() => false));
    }
  }, [data, isCollapse]);

  const handleCollapseRow = (index: number) => {
    if (isCollapse) {
      if (isMultiCollapse) {
        setActiveRow((prev) => prev.map((e, idx) => (idx === index ? !e : e)));
      } else {
        setActiveRow((prev) =>
          prev.map((e, idx) => (idx === index ? !e : false))
        );
      }
    }
  };

  return (
    <Main>
      <TableContainer>
      <MainTable className={responsiveType === "card" ? "cardTable " : "" + tableClassName}>
          <Thead>
            <tr>
              <Each
                of={columns}
                render={(col) => (
                  <Th
                    style={{ width: col.width, ...col.style }}
                    className={col.headingClassName}
                  >
                    {col.header}
                  </Th>
                )}
              />
            </tr>
          </Thead>
          <tbody>
            {data?.length > 0 ? (
              <Each
                of={data}
                render={(ele, index) => (
                  <React.Fragment key={index}>
                    <Row
                      className={isCollapse ? "collapseAbleRow" : ""}
                      onClick={() => handleCollapseRow(index)}
                    >
                      <Each
                        of={columns}
                        render={(col) => (
                          <Td data-cell={col.header} style={col.style}>
                            {col.accessor(
                              ele,
                              index,
                              pageNo && (pageNo - 1) * pageSize + index + 1
                            )}
                          </Td>
                        )}
                      />
                    </Row>
                    {isCollapse && activeRow[index] && CollapseChild && (
                      <Row className={collapseRowClass}>
                        <CollapseCell colSpan={columns?.length}>
                          <CollapseChild data={ele} index={index} />
                        </CollapseCell>
                      </Row>
                    )}
                  </React.Fragment>
                )}
              />
            ) : (
              <Row className="errorRow">
                <Td colSpan={columns.length}>No data found.</Td>
              </Row>
            )}
          </tbody>
        </MainTable>
      </TableContainer>
      {isPaginated && pageNo > 0 && totalPages > 0 && (
        <PaginationContainer>
          <Pagination
            totalPages={totalPages}
            currentPage={pageNo}
            setCurrentPage={setPageNo}
            prevBtnLabel={prevBtnLabel}
            nextBtnLabel={nextBtnLabel}
          />
        </PaginationContainer>
      )}
    </Main>
  );
};

export { Table };
